<div>
  <p>button-alpha</p>
  <button nz-button nzType="primary">Button Alpha</button>
</div>
<div>
  <p>button-beta</p>
  <button nz-button nzType="primary" class="beta">Button Beta</button>
</div>
<div>
  <p>button-gamma</p>
  <button nz-button nzType="primary" ngClass="gamma">Button Gamma</button>
</div>
<div>
  <p>button-zeta (gamepad with notification)</p>
  <button nz-button nzType="primary" ngClass="zeta">
    <span nz-icon nzType="play-circle" nzTheme="outline"></span>
    <div class="notification-badge">4</div>
  </button>
</div>

<div>
  <p>input-alpha</p>
  <input nz-input nzType="primary" placeholder="Input Alpha" />
  <p>input-beta</p>
  <input nz-input nzType="primary" class="beta" placeholder="Input Beta" />
</div>

<div>
  <p>select-alpha</p>
  <nz-select nztype="primary" ngModel="lucy">
    <nz-option nzValue="jack" nzLabel="Jack"></nz-option>
    <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
    <nz-option nzValue="disabled" nzLabel="Disabled" nzDisabled></nz-option>
  </nz-select>
</div>

<div>
  <p>select-beta</p>
  <nz-select
    nztype="primary"
    ngModel="lucy"
    ngClass="beta"
    [nzCustomTemplate]="defaultTemplate"
    >>
    <nz-option nzValue="jack" nzLabel="Jack" [nzCustomContent]="true">
      <ng-container>
        <i nz-icon nzType="user"></i>
        <span style="margin-left: 8px">Jack</span>
      </ng-container>
    </nz-option>
    <nz-option nzValue="lucy" nzLabel="Lucy"> </nz-option>
    <nz-option nzValue="disabled" nzLabel="Disabled" nzDisabled>
      <i nz-icon nzType="user"></i>
      Jack
    </nz-option>
  </nz-select>
  <ng-template #defaultTemplate let-selected>
    <i nz-icon nzType="user"></i>
    <span style="margin-left: 8px">{{ selected.nzLabel }}</span>
  </ng-template>
</div>

<div style="background: #e34; padding: 10px">
  <p>tag-alpha</p>
  <nz-tag ngClass="alpha">Value 1</nz-tag>

  <p>tag-beta</p>
  <nz-tag ngClass="beta">Value 2</nz-tag>

  <p>tag-gamma</p>
  <nz-tag [nzMode]="'closeable'" ngClass="gamma">Value 2</nz-tag>
</div>

<div>
  <p>checkbox-alpha</p>
  <label nz-checkbox>Checkbox</label>
</div>

<div>
  <p>switch-alpha</p>
  <nz-switch></nz-switch>
</div>


<h1>Keys 7 - Modules</h1>

<app-game-card-alpha  *ngIf="data" [data]="data"></app-game-card-alpha>

<!-- <app-sidebar></app-sidebar> -->

<app-game-card-beta *ngIf="data" [data]="data"></app-game-card-beta>

<app-game-card-gamma *ngIf="data" [data]="data"></app-game-card-gamma>

<app-game-ad-beta></app-game-ad-beta>


<app-game-ad-alpha></app-game-ad-alpha>

<div style=" font-size: 36px; background: #333; padding: 10px">
  <h1>ICONS</h1>
  <span nz-icon nzType="ng-zorro:ea-app"></span>
  <span nz-icon nzType="ng-zorro:steam-app"></span>
  <span nz-icon nzType="ng-zorro:gog-com"></span>
  <span nz-icon nzType="ng-zorro:epic-games"></span>
  <span nz-icon nzType="ng-zorro:riot-games"></span>
  <span nz-icon nzType="ng-zorro:battle-net"></span>
  <span nz-icon nzType="ng-zorro:playstation"></span>
  <span nz-icon nzType="ng-zorro:xbox"></span>
  <span nz-icon nzType="ng-zorro:nintendo"></span>
</div>
